/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateKpIsFromExcelSheetResult } from '../../models/create-kp-is-from-excel-sheet-result';

export interface ApiKpIsCreateKpIsFromExcelSheetPost$Plain$Params {
      body?: {
'ExcelFile'?: Blob;
'CategoryId'?: string;
}
}

export function apiKpIsCreateKpIsFromExcelSheetPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpIsCreateKpIsFromExcelSheetPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateKpIsFromExcelSheetResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpIsCreateKpIsFromExcelSheetPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateKpIsFromExcelSheetResult>;
    })
  );
}

apiKpIsCreateKpIsFromExcelSheetPost$Plain.PATH = '/api/KPIs/CreateKPIsFromExcelSheet';
